import * as Sentry from "@sentry/nextjs"


const SENTRY_DSN =
  process.env.SENTRY_DSN ||
  process.env.NEXT_PUBLIC_SENTRY_DSN
const SENTRY_RELEASE =
  process.env.SENTRY_RELEASE || process.env.NEXT_PUBLIC_SENTRY_RELEASE
const SENTRY_ENV =
  process.env.SENTRY_ENV ||
  process.env.NEXT_PUBLIC_SENTRY_ENV

Sentry.init({
  enabled: process.env.NODE_ENV === "production" ? true : false,
  dsn: SENTRY_DSN,
  tracesSampleRate: 1.0,
  environment: SENTRY_ENV,
  release: SENTRY_RELEASE,
})
